export const MARKET_LIST = 'MARKET_LIST';
export const MARKET_UPDATE = 'MARKET_UPDATE';
export const MARKET_TRADE_LIST = 'MARKET_TRADE_LIST';
export const MARKET_TRADE_STORE = 'MARKET_TRADE_STORE';
export const MARKET_UPDATE_STATS = 'MARKET_UPDATE_STATS';
